// Phase 15 Plan 05 Task 2 — DEC-009 single-source-of-truth derived stores.
//
// All five active-match-cap consumers MUST bind these computed selectors:
//   1. LobbyScreen badge        (Plan 06)
//   2. CreateMatchCluster CTAs  (Plan 06 — disabled when $isAtCap)
//   3. ProfileScreen own-profile chip (Plan 08)
//   4. PublicProfileResponse Challenge button (Plan 08)
//   5. Tournament card slot UI  (Plan 10)
//
// Drift between any two of these = lobby badge says "3/3" while a Create
// button is still enabled = Pitfall 7 in 15-RESEARCH.md. Reading from a
// single `computed()` selector eliminates the drift by construction.

import { computed } from 'nanostores'
import { $lobbyData } from './lobbyData'

/**
 * Active match count (PvP only — excludes bot-practice + tournament-round
 * per DEC-009). Server-projected from the lobby payload.
 */
export const $activeMatchCount = computed(
  $lobbyData,
  (data) => data?.active_match_count ?? 0,
)

/**
 * Active-match cap. Default 3 until the lobby responds (DEC-009 default;
 * the server's payload always overwrites this within 30s of first paint).
 */
export const $activeMatchCap = computed(
  $lobbyData,
  (data) => data?.active_match_cap ?? 3,
)

/** True iff count >= cap. */
export const $isAtCap = computed(
  [$activeMatchCount, $activeMatchCap],
  (count, cap) => count >= cap,
)
